import { loggerScope } from './_common/client/logger';
import { sendCustomError } from '@otto-ec/global-resources/apm';

type ErrorType = 'GeneralError' | 'OnHtmlLoadedError' | 'OnInitError' | 'OnReloadComponentEvent';

export type LogErrorParams = {
    type?: ErrorType;
    error?: Error;
    message?: string;
    data?: Record<string, string | number | boolean>;
};

const log = loggerScope.scope('client-component-logger');

/**
 * logger that can log to server.
 * never throws an error
 */
export class ClientComponentLogger {
    constructor(private readonly componentName: string) {}

    public logError(params: LogErrorParams): void {
        try {
            const errorData = {
                componentName: this.componentName,
                errorType: params.type || 'GeneralError',
                errorMessage: params.message || params.error?.message || '',
                errorObj: params.error?.stack || '',
                ...params.data,
            };

            log.error(errorData);

            const asRumErrorData = {
                ...errorData,
                // AS.RUM sends custom requests using a get request to a gif element. The maximum length for URIs is 2048
                // characters, therefor we cut the stack trace after 1500 characters.
                errorObj: errorData.errorObj.substring(0, 1500),
            };

            sendCustomError('ft5.component-repository', asRumErrorData);
        } catch (e) {
            log.error('Error by ClientComponentLogger#logError ! should never happen :/', e);
        }
    }
}
